import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'

import {
  BatchTrcBooksAndAvRegPageLoadResult,
  BatchTrcBooksAndAvRegPageLoadResultFromJSON
} from '@/api/models/batch/BatchTrcBooksAndAvRegPageLoadResult'

import {
  BatchTrcBooksAndAvRegRequest,
  BatchTrcBooksAndAvRegRequestToJSON
} from '@/api/models/batch/BatchTrcBooksAndAvRegRequest'

export class BatchTrcBooksAndAvRegApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcBooksAndAvRegPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcBooksAndAvRegPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createTrcAvRegist(
    request: BatchTrcBooksAndAvRegRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/regist-trc-marc`,
      BatchTrcBooksAndAvRegRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
